module.exports = __webpack_public_path__ + "img/telenrollimg.b0079611.png";